__turbopack_context__.v({
  "avnIcon": "bsfQAW_avnIcon",
  "label": "bsfQAW_label",
  "span": "bsfQAW_span",
  "stsIcon": "bsfQAW_stsIcon",
});
